import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";
import Waiting from './../modules/waiting';
import Message from './errors/messagePrem';
import SimpleHeader from './../modules/simpleHeader_prem';
import Card from './../modules/paymentMethods/card_prem';
import Wallet from './../modules/paymentMethods/wallet_prem';
import Cash from './../modules/paymentMethods/cash_prem';
import Aman from './../modules/paymentMethods/aman_prem';
import Jawwal from './../modules/paymentMethods/Jawwal';
import Premium from './../modules/paymentMethods/premium_prem';
import Delivery from './../modules/paymentMethods/delivery_prem';
import amanImg from './../../statics/img/payment_methods_logos/logo_aman.png';
import masaryImg from './../../statics/img/payment_methods_logos/logo_masary.png';
import cashImg from './../../statics/img/payment_methods_logos/logo_cash.png';
import cardImg from './../../statics/img/payment_methods_logos/logo_mc_visa.png';
import walletImg from './../../statics/img/payment_methods_logos/logo_wallet.png';
import premiumImg from './../../statics/img/payment_methods_logos/logo_premium.gif';
import './../custom.css';
import './invoice.css';
import SubData from './../modules/paymentMethods/sub-data_prem';
import { Container, Row, Col,Table } from 'reactstrap';

import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import creditCard from './../../statics/premCheck/credit-card.png';
import funds from './../../statics/premCheck/funds.png';
import vodafone from './../../statics/premCheck/vodafone.png';
import kiosk from './../../statics/premCheck/kiosk.png';
import valu from './../../statics/premCheck/valu.png';
import wallet from './../../statics/premCheck/wallet.png';
import user from './../../statics/premCheck/user.png';
import footerLogo from './../../statics/premCheck/Logo.png';
import valuImg from './../../statics/img/payment_methods_logos/ValU.png';
import acceptWhiteImg from './../../statics/img/accept_white.png';
import success from './../../statics/premCheck/success.png';
import fail from './../../statics/premCheck/fail.png';
import favicon from './../../statics/img/favicon.svg';
import favicon_jawwal from './../../statics/img/fav_icon.png';


class invoice extends Component {
    constructor(props){
        super(props);
        this.state = {
            dataLoaded: false,
            userData: null,
            requestComplete: false,
            completeMessage: {'head': "", 'body': ""},
            currentMethod: '',
            //reverse sort array
            sortArr: ['CASH','UIG','CAGG','VPC'],
            MethodsName: {
                VPC: "Card",
                UIG: "Wallet",
                CASH: "Cash Collection",
                CAGG: "Accept Kiosk",
                PREMIUM: "Premium",
                MPAY: "Jawwal Pay"
            },
            paymentMethodsDisable: false,
            deliveryDataCollected: false,
            deliveryData: {

            },
            SubDataComplelte:true,
            firstPhase:true,
            //acq_partner
            acq_partner: false,
            styleData: {},
        };
        this.renderError  = this.renderError.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.paymentsMethods = this.paymentsMethods.bind(this);
        this.renderCurrentImg = this.renderCurrentImg.bind(this);
        this.disableAllPaymentMethods = this.disableAllPaymentMethods.bind(this);
        this.enableAllPaymentMethods = this.enableAllPaymentMethods.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.currentPaymentMethodComponent = this.currentPaymentMethodComponent.bind(this);
        this.setDeliveryData = this.setDeliveryData.bind(this);
        this.setReqComplete = this.setReqComplete.bind(this);
        this.setPartnerColors = this.setPartnerColors.bind(this);
        this.loadData = this.loadData.bind(this);
        this.loadStyleData = this.loadStyleData.bind(this);
        this.setSubDataComplelte = this.setSubDataComplelte.bind(this);
        this.firstPhaseToggle = this.firstPhaseToggle.bind(this);

        
    }
    componentDidMount(){
        this.loadStyleData();
    }
    firstPhaseToggle(){
        this.setState({firstPhase: !this.state.firstPhase});
    }
    setSubDataComplelte(){
        this.setState({SubDataComplelte: true});
    }
    loadStyleData(){
        let styleUrl = appConfig.getServerUrl() + '/api/auth/acq_partners/style?url=' + window.location.hostname ;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            styleUrl,
            config
        )
        .then((respond)=>{
            this.setState({styleData: respond.data, acq_partner: true},()=>{
                this.loadData();
            })
        })
        .catch((err)=>{
            this.loadData();
        });
    }
    loadData(){
        let token = this.props.token;
        let invoiceUrl = appConfig.getServerUrl() + '/invoice_prem/' + token;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            invoiceUrl,
            config
        )
        .then((respond)=>{
            if(respond.data.error){
                this.setReqComplete({head: '', body: respond.data.error,icon:fail});
            }else{
                this.setState({userData: respond.data, dataLoaded: true},()=>{
                    let current_integrations_keys = [];
                    let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
                    for(let i=0; i< all_integ_key_arr.length;i++){
                        if(this.state.MethodsName[all_integ_key_arr[i]]){
                            current_integrations_keys.push(all_integ_key_arr[i]);
                        }
                    }
                    this.state.sortArr.map((ele)=>{
                        if(current_integrations_keys.indexOf(ele) != -1){
                            current_integrations_keys.splice(current_integrations_keys.indexOf(ele),1);
                            current_integrations_keys.unshift(ele)
                        }
                    })
                    this.setState({currentMethod: current_integrations_keys[0]},()=>{
                        if(this.state.acq_partner){
                            this.setPartnerColors(this.state.styleData)
                        }else{
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.rel="shortcut icon"
                            link.type = 'image/x-icon'
                            link.href= favicon;
                        }
                    });

                });
                localStorage.userData=JSON.stringify(respond.data)
            }

        })
        .catch((err)=>{
            if(this.state.acq_partner){
                this.setPartnerColors(this.state.styleData)
            }else{
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon;
            }
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    setPartnerColors(data){
        setTimeout(()=>{
            document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.rel="shortcut icon"
            link.type = 'image/x-icon'
            link.href= favicon_jawwal;
        },40)
    }
    paymentsMethods(){
        let current_integrations_keys = [];
        let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
        for(let i=0; i< all_integ_key_arr.length;i++){
            if(this.state.MethodsName[all_integ_key_arr[i]]){
                current_integrations_keys.push(all_integ_key_arr[i]);
            }
        }   
        this.state.sortArr.map((ele)=>{
            if(current_integrations_keys.indexOf(ele) != -1){
                current_integrations_keys.splice(current_integrations_keys.indexOf(ele),1);
                current_integrations_keys.unshift(ele)
            }
        })  
        return(
            <RadioGroup className="methodsContent" name="radio" defaultValue={current_integrations_keys[0]} onChange = {this.handleMethodChange}>
            {current_integrations_keys.map((key, index) => {
                return <Radio 
                    radioClass="iradio_flat-green"
                    increaseArea="20%"
                    key= {key}
                    value={key}
                    label={"<div class='paymentIcon'>"+ this.renderCurrentImg(key)+"</div>" + "<span>" +this.state.MethodsName[key] + "</span>" }
                    // disabled={this.state.paymentMethodsDisable}
                />
            })} 
        </RadioGroup>
        );
    }
    // renderCurrentImg(key){
    //     let allowedAggre = this.state.userData.allowed_aggregators;
    //     if(key === 'VPC'){
    //         return "<img class='paymentMethodImg' src=" + cardImg + " alt=" + key + " />"
    //     }else if(key === 'UIG'){
    //         return "<img class='paymentMethodImg' src=" + walletImg + " alt=" + key + " />"
    //     }else if(key === 'CASH'){
    //         return "<img class='paymentMethodImg' src=" + cashImg + " alt=" + key + " />"
    //     }else if(key === 'CAGG'){
    //         if(allowedAggre === "aman"){
    //             return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " />"
    //         }else if(allowedAggre === "masary"){
    //             return "<img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
    //         }else if(allowedAggre === "aman/masary"){
    //             return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " /><img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
    //         }else{
    //             return ''
    //         }
    //     }else if(key === 'PREMIUM'){
    //         return "<img class='paymentMethodImg' src=" + premiumImg + " alt=" + key + " />"
    //     }
    //     return ''
    // }
    renderCurrentImg(key){
        let allowedAggre = this.state.userData.allowed_aggregators;
        if(key === 'VPC'){
            return "<img class='' src=" + creditCard + " alt=" + key + " /></div>"
        }else if(key === 'UIG'){
            return "<img class='' src=" + wallet + " alt=" + key + " />"
        }else if(key === 'CASH'){
            return "<img class='' src=" + funds + " alt=" + key + " />"
        }else if(key === 'CAGG'){
            return "<img class='' src=" + kiosk + " alt=" + key + " />"
        }else if(key === 'PREMIUM'){
            return "<img class='' src=" + valu + " alt=" + key + " />"
        }else if(key === 'VALU'){
            return "<img class='paymentMethodImg' src=" + valuImg + " alt=" + key + " />"
        }
        return ''
    }
    disableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: true});
    }
    enableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: false});
    }
    handleMethodChange(e){
        this.setState({currentMethod: e.target.value});
    }

    renderPaymentMethod() {
        let deliveryNeed = this.state.userData.order_delivery;
        if(deliveryNeed === false){
            return this.currentPaymentMethodComponent();
        }else if (deliveryNeed === true){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <Delivery sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}
                        currentDeliveryData={this.state.deliveryData}
                        setSubDataComplelte={this.setSubDataComplelte} 

                        />
              
            }
        }
        
    }
    setDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}});
    }
    setReqComplete(Message){
        this.setState({requestComplete: true, completeMessage: Message, dataLoaded: true});
    }
    currentPaymentMethodComponent() {
        let currentMethod = this.state.currentMethod;
        let deliveryNeed = this.state.userData.order_delivery;
        if( currentMethod === 'VPC'){
            if(deliveryNeed === false){
                return <Card
                    sourcePage='invoice'
                    deliveryNeed={false} deliveryData={null} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Card 
                    sourcePage='invoice'
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'UIG'){
            if(deliveryNeed === false){
                return <Wallet sourcePage='invoice' deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete}/>
            }else if (deliveryNeed === true){
                return <Wallet sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CASH'){
            if(this.state.deliveryDataCollected){
                return <Cash sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} setDeliveryData={this.setDeliveryData} />
            }else{
                return <Delivery sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData} setSubDataComplelte={this.setSubDataComplelte}/>
            }
            if(deliveryNeed === false){
                return <Wallet deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Wallet deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CAGG'){
            if(deliveryNeed === false){
                return <Aman sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Aman sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'PREMIUM'){
            if(deliveryNeed === false){
                return <Premium sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Premium sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'MPAY'){
            if(deliveryNeed === false){
                return <Jawwal sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Jawwal sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else{
            return <p>{this.state.MethodsName[this.state.currentMethod]}</p>
        }
    }
    renderError(){
        return ( 
            <div className="invoice">
                <Container>
                        <div className="checkHeader invoiceHeader">
                            <div className="leftInvoice">
                                <div className="compLogo">
                                    <a href="#">
                                        <img src={this.state.userData.logo_uri==""?user:appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                    </a>
                                </div>
                                <p className="companyName">
                                {this.state.userData.order_merchant_name}
                                </p>
                            </div>
                            <div className="invoiceAmount">
                                <p>Order Amount</p>
                                <b>{this.state.userData.order_amount_egp + ' ' + this.state.userData.order_currency}</b>
                            </div>
                        </div>
                    </Container>
                <Message body={this.state.userData.errorMessage} />
            </div>
        );
    }
    
    renderBody(){
        if(this.state.requestComplete){
            let userData=this.state.userData;
            return ( 
                <div className="invoice">
                <Container>
                  <div className="checkHeader invoiceHeader">
                    <div className="leftInvoice">
                        {userData && 
                            <div className="compLogo">
                                <a href="#">
                                    <img src={!userData.logo_uri?user:appConfig.getServerUrl() + userData.logo_uri }/>
                                </a>
                            </div>
                        }
                        {userData && 
                            <p className="companyName">
                                {userData.merchant_name?userData.merchant_name:"-"}
                            </p>
                        }
                        </div>
                    </div>
                </Container>

                    <div>
                        <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body} icon={this.state.completeMessage.icon}/>
                    </div>
                    <div className="premFooter">
                        <p>Powered By</p>
                        <a href="https://www.weaccept.co/"><img src={footerLogo}></img></a>
                    </div>
                </div>
            );
        }else{
            return (
                <div>
                    {
                        this.state.firstPhase?
                        <div className="invoiceFirst">
                            <div className="descBody">
                                <div className="descHeader">
                                    <div className="compImg">
                                        <a href="#">
                                            <img src={this.state.userData.logo_uri==""?user:appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                        </a>
                                    </div>
                                    <p className="companyName">
                                        {this.state.userData.order_merchant_name}
                                    </p>
                                    <h3>
                                    Invoice
                                    </h3>
                                </div>
                                <div className="billingFrom">
                                    <div className="side">
                                        <h4>Billing From</h4>
                                        <div className="item">
                                            <h3>Name:</h3>
                                            <p>{this.state.userData.order_merchant_name}</p>
                                        </div>
                                        <div className="item">
                                            <h3>Phone Number:</h3>
                                            <p>{this.state.userData.merchant_mobiles[0]}</p>
                                        </div>
                                        <div className="item">
                                            <h3>Email Address:</h3>
                                            <p>
                                            {
                                                this.state.userData.merchant_emails!=""?
                                                    this.state.userData.merchant_emails.map((ele,index)=>{
                                                        return <h3 key={index}>{this.state.userData.merchant_emails[index]}</h3>

                                                        })
                                                    :
                                                    null
                                            }
                                            </p>
                                        </div>
                                        {/* <div className="item">
                                            <h3>Website:</h3>
                                            <p></p>
                                        </div> */}
                                    </div>
                                    <div className="side">
                                        {/* <div className="item">
                                            <h3>Invoice Number:</h3>
                                            <p></p>
                                        </div> */}
                                        <h4>Order Details</h4>
                                        <div className="item">
                                            <h3>Invoice Date:</h3>
                                            <p>{new Date(this.state.userData.order_creation).getDate() + " / " + (new Date(this.state.userData.order_creation).getMonth() + 1) + " / " + new Date(this.state.userData.order_creation).getFullYear()}</p>
                                        </div>
                                        <div className="item">
                                            <h3>Order Name: </h3>
                                            <p>{this.state.userData.order_name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="billTo">
                                    <h2>Bill to:</h2>
                                    <div className="side">
                                        <div className="item">
                                            <h3>{this.state.userData.order_email}</h3>
                                        </div>
                                        <div className="item">
                                            <h3>{this.state.userData.order_phone }</h3>
                                        </div>
                                       
                                    </div>
                                </div>
                                <div className="descTable">
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th className="rounded-left">Description</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{this.state.userData.order_name}{this.state.userData.order_description ? " : "+this.state.userData.order_description : ""}</td>
                                                <td>{this.state.userData.order_amount_egp + ' ' + this.state.userData.order_currency}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="center">
                                    <button className="btn btn-primary active premBtn" onClick={this.firstPhaseToggle}>Pay</button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="invoice">
                            <Container>
                                <div className="checkHeader invoiceHeader">
                                    <div className="leftInvoice">
                                        <div className="compLogo">
                                            <a href="#">
                                                <img src={this.state.userData.logo_uri==""?user:appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                            </a>
                                        </div>
                                        <p className="companyName">
                                        {this.state.userData.order_merchant_name}
                                        </p>
                                    </div>
                                    <div className="invoiceAmount">
                                        <p>Order Amount</p>
                                        <b>{this.state.userData.order_amount_egp + ' ' + this.state.userData.order_currency}</b>
                                    </div>
                                </div>
                            </Container>
                            <Container>
                                <div className="right_col" role="main" id="content">
                                    <div className="row" id="orderDetails">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                                            <div className="premPanel">
                                                    <div className="premPanel">
                                                        <div className="premHeader" >
                                                            <h2>Choose Payment Method</h2>
                                                        </div>
                                                        <div className="paymentMethods">
                                                            {this.paymentsMethods()}
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                                            {this.renderPaymentMethod()}                            
                                        </div>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    }
                    {this.state.acq_partner ? 
                        <div className="premFooter" style={{background: this.state.styleData.partner_css.header_background}}>
                            <p>Powerd by</p>
                            <a href={this.state.styleData.partner_redirect_url}><img src={this.state.styleData.partner_logo}></img></a>
                        </div>
                    :
                        <div className="premFooter">
                            <p>Powerd by</p>
                            <a href="https://www.weaccept.co/"><img src={footerLogo}></img></a>
                        </div>
                    }
                </div>
                   
            );
        }
    }
    render(){
        //let userData = JSON.parse(localStorage.userData);
        // JSON.stringify
        return (
            <div>
                {this.state.dataLoaded?this.renderBody():<Waiting height='100vh' />}
            </div>
        );
    }
    
}

export default invoice;
